import type { AssetRiskAvatarProps } from "./asset-risk-avatar.type";

import { Avatar, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { useAssetRisksReferential } from "@/modules/asset/asset-risk";
import { getAcronym } from "@/utilities/string";

export const AssetRiskAvatar = ({ asset }: AssetRiskAvatarProps) => {
  const { t } = useTranslation();
  const { getRiskLevel } = useAssetRisksReferential();
  const risk = getRiskLevel(asset?.risk_level);

  if (!risk) return null;

  return (
    <Tooltip title={t("asset:risk:label") + ": " + risk.name}>
      <Avatar style={{ backgroundColor: risk.color }}>
        {getAcronym(risk.name)}
      </Avatar>
    </Tooltip>
  );
};
